<ng-container *ngIf='dashResponse; else waiting'>
      <ng-container *ngIf='modifyMsgId'>
              
        <div class='actionBar' style='margin-top: 50px'>
          <h5 *ngIf="modifyMsgId=='new'; else existing" class="roboSubTitle col">{{'configuration.dashboard.new' | translate}}<br *ngIf="innerWidth! <= 767"></h5>
          <ng-template #existing>
            <h5  class="roboSubTitle col">{{'configuration.dashboard.modify' | translate}} <small> (id: {{modifyMsgId}})</small><br *ngIf="innerWidth! <= 767"></h5>
          </ng-template>
          <button  type="submit" class="btn btn-primary" style="margin-right: 10px;" (click)='undo()'>{{ 'general.undo' | translate }}</button>
          <button  type="submit" class="btn btn-primary" style="margin-right: 10px;" (click)='save(modifyMsgId)'>{{ 'general.save' | translate }}</button>
          
          <button type="button" class="btn btn-danger" (click)="deleteMsg(modifyItem)"><img src="assets/icone_varie/cestino.svg"></button>
          
        </div>
        <hr>
        <div class='row'>
          <div  [ngClass]="{'col-8' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" class="mb-4">
            <angular-editor  [(ngModel)]="modifyItem.messaggio" [config]="editorConfig"></angular-editor>
            <!--<textarea class="form-control" type="text" id="username" [(ngModel)]="modifyItem.messaggio" style="height: 150px;"></textarea>-->
          </div>
          <div  [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            <div class="container  form-group">
            <input type="checkbox" class="form-check-input"  [(ngModel)]="modifyItem.attivo">
            <label class="form-check-label" >{{'configuration.dashboard.active' | translate}}</label>
            </div>
            <!--<hr>
            <div class="container  form-group">
              <label [ngClass]="[modifyItem.tipo != '' ? 'colorGreen' : 'colorRed']">{{'configuration.dashboard.type' | translate}}</label>
              <app-select  class="selectDm7" 
              [options]="configProps!.tipoNotificaDashboard"
              [key]="'val'" [value]="'label'"
              [placeholder]="'configuration.dashboard.type' | translate" [addNull]="true" [selectedKey]="modifyItem.tipo" (change)="modifyItem.tipo= $event.key;restoreRivenditore()"
              [valClass]="[modifyItem.tipo != '' ? 'borderGreen' : 'borderRed']"></app-select>
            </div>

            <div *ngIf="modifyItem.tipo=='private'" class="container  form-group">
              <label [ngClass]="modifyItem.tipo=='private' && modifyItem.rivenditore==''?'colorRed':''">{{'configuration.dashboard.reseller' | translate}}</label>
              <div class="input-group" style="flex: 1">
                <input id="btnPass" id="btnPassEnv" type="text" class="form-control" [(ngModel)]="modifyItem.rivenditore"
                          [placeholder]="'placeholder.search' | translate"  disabled  [ngClass]="modifyItem.tipo=='private' && modifyItem.rivenditore==''?'borderRed':''"/>
                <span  class="input-group-text" id="basic-addon1" (click)="openModalRivenditori()">
                    <i class="bi bi-search" [ngbTooltip]="'configuration.dashboard.searchReseller' | translate"></i> 
                </span>
              </div>
            </div>-->
          </div>
        </div>          
    </ng-container>
      <div>
          <table class="table" >
            <thead>
              <tr >
                <th scope="col">ID</th> 
                <th scope="col"  style="width: 40%">{{'configuration.dashboard.msg' | translate}}</th>
                <th scope="col"  >{{'configuration.dashboard.active' | translate}}</th>
                <!--<th scope="col"  >{{'configuration.dashboard.admin' | translate}}</th>
                <th scope="col"  >{{'configuration.dashboard.type' | translate}}</th>-->
                <th scope="col" style='text-align: right;'> 
                  <button type="button" class="btn btn-primary" (click)="refresh()" style="margin-right: 20px"><img src="assets/icone_varie/refresh.svg"></button>
                  <button type="button" class="btn btn-primary" (click)='addMsg()'><i class="bi bi-plus"></i> {{ 'general.add' | translate }}</button> </th>
              </tr>
            </thead> 
            <tbody>
              <tr *ngFor="let u of msgList; let i = index;" >
                <td>
                  {{u.id}}
                </td>
                <td>
                    {{u.messaggio}}
                </td>
                <td>
                  <img [src]="'assets/icone_varie/' + (u.attivo ? 'check_1.svg' : 'inactive.svg')"
                  style='width:20px;height:auto'>
                </td>
                <!--<td>
                    {{u.user_id}}
                </td>
                <td [innerHTML]="getTypeName(u.tipo,i)">
                  
                </td>-->
                <td >
                  <button  type="button" class="btn btn-primary" (click)="modifyMsg(u)" style='margin-right: 10px'><img src="assets/icone_varie/modifica.svg"></button>
                  <button type="button" class="btn btn-danger" (click)="deleteMsg(u)"><img src="assets/icone_varie/cestino.svg"></button>
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
      
        <ng-container *ngIf='!msgList'>
          <div>
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
          </div>
        </ng-container>

        
  
  </ng-container>
  <ng-template #waiting>
      <app-loading></app-loading>
  </ng-template>